import { filterChipSx } from '../designTokens';
import { resolveAccountCategoryOptions } from './accountCategories';
import {
  ChatBubbleOutline as PromptIcon,
  HandymanOutlined as SkillIcon,
  SmartToyOutlined as AgentIcon,
} from '@mui/icons-material';

/** Builder category chips — display label is the stored category value. */
export const BUILDER_CATEGORY_OPTIONS = [
  'Sales & GTM',
  'Marketing & Content',
  'Customer Success & Support',
  'Operations',
  'Product & Design',
  'Engineering & IT',
  'Data & Analytics',
  'Finance & Legal',
  'People & HR',
  'Strategy & Planning',
  'Research & Learning',
  'Compliance & Risk',
  'Other',
];

export const CAPABILITY_TYPE_OPTIONS = [
  { value: 'prompt', label: 'Simple', hint: 'Chat prompt that can run without integrations or agent runtimes', Icon: PromptIcon },
  { value: 'skill', label: 'Integrated', hint: 'Prompt workflow that uses tools, platforms, files, or integrations', Icon: SkillIcon },
  { value: 'agent', label: 'Autonomous', hint: 'Scheduled or event-driven workflow with reduced human involvement', Icon: AgentIcon },
];

export function resolveCapabilityType(capabilityType) {
  const match = CAPABILITY_TYPE_OPTIONS.find((t) => t.value === (capabilityType || 'prompt'));
  return match || CAPABILITY_TYPE_OPTIONS[0];
}

export function getCapabilityTypeLabel(capabilityType) {
  return resolveCapabilityType(capabilityType).label;
}

/** Primary metadata — capability type chips (selected clear; unselected subdued). */
export function getBuilderTypeChipSx(selected) {
  if (selected) {
    return {
      ...filterChipSx(true),
      height: 26,
      fontSize: '0.8125rem',
      lineHeight: 1.2,
      '& .MuiChip-label': {
        px: 1.35,
        display: 'inline-flex',
        alignItems: 'center',
      },
      '& .MuiChip-icon': {
        ml: 0.625,
        mr: -0.25,
        display: 'inline-flex',
        alignItems: 'center',
      },
    };
  }
  return {
    height: 26,
    fontSize: '0.8125rem',
    lineHeight: 1.2,
    fontWeight: 500,
    borderRadius: 999,
    borderColor: '#E2E8F0',
    bgcolor: 'transparent',
    color: '#64748B',
    '& .MuiChip-label': {
      px: 1.35,
      display: 'inline-flex',
      alignItems: 'center',
    },
    '& .MuiChip-icon': {
      ml: 0.625,
      mr: -0.25,
      display: 'inline-flex',
      alignItems: 'center',
    },
    '&:hover': {
      bgcolor: 'rgba(15, 23, 42, 0.04)',
      borderColor: '#CBD5E1',
      color: '#334155',
    },
  };
}

/** Secondary metadata — neutral, compact category chips. */
export function getBuilderCategoryChipSx(selected) {
  const chipColors = filterChipSx(selected);
  return {
    ...chipColors,
    height: 26,
    fontSize: undefined,
    fontWeight: undefined,
    '& .MuiChip-label': {
      px: 1,
      fontSize: '0.75rem',
      fontWeight: selected ? 600 : 500,
      lineHeight: 1.2,
      letterSpacing: 'normal',
    },
  };
}

export function resolveBuilderCategories(accountCategories = []) {
  return resolveAccountCategoryOptions(accountCategories);
}

export function getCapabilityTypeHintLine(capabilityType) {
  const match = CAPABILITY_TYPE_OPTIONS.find((t) => t.value === capabilityType);
  if (!match) return '';
  return `${match.label} — ${match.hint}`;
}
